import { useSelector } from 'react-redux'

import NotificationDialog from '@/components/NotificationDialog'
import { dialogFlashMessageSelector } from '@/selectors'

const FlashDialog = () => {
  const dialog = useSelector(dialogFlashMessageSelector)
  const isShowing = dialog

  return (
    <If condition={isShowing}>
      <NotificationDialog message={{
          text: dialog.text,
          type: dialog.type
        }}
      />
    </If>
  )
}

export default FlashDialog
